import React, { useState } from 'react';
import { MdLayers } from "react-icons/md";

const styles = {
  truncatedLabel: {
    display: '-webkit-box',
    WebkitLineClamp: 2,
    WebkitBoxOrient: 'vertical',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    maxWidth: '100%',
    lineHeight: '1.4',
  },
};

const LayerSelection = ({
  showIndicator3,
  setShowIndicator3,
  showIndicator4,
  setShowIndicator4,
  showIndicator5,
  setShowIndicator5,
  showColorLayer,
  setShowColorLayer,
  showPatternLayer,
  setShowPatternLayer,
  setMapConfigData,
  showPieChart, // New prop
  setShowPieChart, // New prop
}) => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleDropdown = () => setIsOpen(!isOpen);

  const indicator_1_name = setMapConfigData?.colorIndicator?.label;
  const indicator_2_name = setMapConfigData?.patternIndicator?.label;
  const indicator_3_name = setMapConfigData?.indicators[0]?.label;
  const indicator_4_name = setMapConfigData?.indicators[1]?.label;
  const indicator_5_name = setMapConfigData?.indicators[2]?.label;

  const indicator_1_sub_name = setMapConfigData?.colorIndicator?.subIndicator?.label;
  const indicator_2_sub_name = setMapConfigData?.patternIndicator?.subIndicator?.label;
  const indicator_3_sub_name = setMapConfigData?.indicators[0]?.subIndicator?.label;
  const indicator_4_sub_name = setMapConfigData?.indicators[1]?.subIndicator?.label;
  const indicator_5_sub_name = setMapConfigData?.indicators[2]?.subIndicator?.label;

  return (
    <div className="position-absolute top-0 end-0 mt-2 me-2 z-3" style={{
  }}>
      {/* Floating toggle button */}
      <button
        className="btn btn-light border rounded-circle shadow-sm p-2"
        onClick={toggleDropdown}
        style={{ width: "50px", height: "50px" }}
      >
        <MdLayers size={20} />
      </button>

      {/* Dropdown menu */}
      {isOpen && (
        <div className="bg-white border shadow rounded p-3 end-0" style={{ position: 'absolute',minWidth: "220px", maxWidth: "280px" ,zIndex: 1000}}>
          <h6 className="mb-3 fw-bold"> Indicator Layers</h6>

          {/* Layer 1 */}
          {indicator_1_name?.trim() && (
            <div className="form-check mb-2 small">
              <input
                className="form-check-input"
                type="checkbox"
                id="colorLayer"
                checked={showColorLayer}
                onChange={(e) => setShowColorLayer(e.target.checked)}
              />
              <label className="form-check-label" htmlFor="colorLayer">
                <span style={styles.truncatedLabel} title={`${indicator_1_sub_name || ''} ${indicator_1_name}`}>
                  {indicator_1_sub_name && (
                    <span className="text-success text-decoration-underline">{indicator_1_sub_name}&nbsp;</span>
                  )}
                  {indicator_1_name}
                </span>
              </label>
            </div>
          )}

          {/* Layer 2 */}
          {indicator_2_name?.trim() && (
            <div className="form-check mb-2 small">
              <input
                className="form-check-input"
                type="checkbox"
                id="patternLayer"
                checked={showPatternLayer}
                onChange={(e) => setShowPatternLayer(e.target.checked)}
              />
              <label className="form-check-label" htmlFor="patternLayer">
                <span style={styles.truncatedLabel} title={`${indicator_2_sub_name || ''} ${indicator_2_name}`}>
                  {indicator_2_sub_name && (
                    <span className="text-success text-decoration-underline"> | {indicator_2_sub_name}&nbsp;</span>
                  )}
                  {indicator_2_name}
                </span>
              </label>
            </div>
          )}

          {/* Indicator 3 */}
          {indicator_3_name?.trim() && setMapConfigData?.chartType?.toLowerCase() === 'pie' && (
            <div className="form-check mb-2 small">
              <input
                className="form-check-input"
                type="checkbox"
                id="indicator3"
                checked={showPieChart}
                onChange={(e) => setShowPieChart(e.target.checked)}
              />
              <label className="form-check-label" htmlFor="indicator3">
                <span style={styles.truncatedLabel} title={`${indicator_3_sub_name || ''} ${indicator_3_name}`}>
                  {indicator_3_sub_name && (
                    <span className="text-success text-decoration-underline"> | {indicator_3_sub_name}&nbsp;</span>
                  )}
                  {indicator_3_name}
                </span>
              </label>
            </div>
          )}

          {/* Indicator 3 */}
          {indicator_3_name?.trim() && setMapConfigData?.chartType?.toLowerCase() !== 'pie' && (
            <div className="form-check mb-2 small">
              <input
                className="form-check-input"
                type="checkbox"
                id="indicator3"
                checked={showIndicator3}
                onChange={(e) => setShowIndicator3(e.target.checked)}
              />
              <label className="form-check-label" htmlFor="indicator3">
                <span style={styles.truncatedLabel} title={`${indicator_3_sub_name || ''} ${indicator_3_name}`}>
                  {indicator_3_sub_name && (
                    <span className="text-success text-decoration-underline"> | {indicator_3_sub_name}&nbsp;</span>
                  )}
                  {indicator_3_name}
                </span>
              </label>
            </div>
          )}

          {/* Indicator 4 */}
          {indicator_4_name?.trim() && (
            <div className="form-check mb-2 small">
              <input
                className="form-check-input"
                type="checkbox"
                id="indicator4"
                checked={showIndicator4}
                onChange={(e) => setShowIndicator4(e.target.checked)}
              />
              <label className="form-check-label" htmlFor="indicator4">
                <span style={styles.truncatedLabel} title={`${indicator_4_sub_name || ''} ${indicator_4_name}`}>
                  {indicator_4_sub_name && (
                    <span className="text-success text-decoration-underline"> | {indicator_4_sub_name}&nbsp;</span>
                  )}
                  {indicator_4_name}
                </span>
              </label>
            </div>
          )}

          {/* Indicator 5 */}
          {indicator_5_name?.trim() && (
            <div className="form-check mb-2 small">
              <input
                className="form-check-input"
                type="checkbox"
                id="indicator5"
                checked={showIndicator5}
                onChange={(e) => setShowIndicator5(e.target.checked)}
              />
              <label className="form-check-label" htmlFor="indicator5">
                <span style={styles.truncatedLabel} title={`${indicator_5_sub_name || ''} ${indicator_5_name}`}>
                  {indicator_5_sub_name && (
                    <span className="text-success text-decoration-underline"> | {indicator_5_sub_name}&nbsp;</span>
                  )}
                  {indicator_5_name}
                </span>
              </label>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default LayerSelection;
